import { render, staticRenderFns } from "./KPIGeneral.vue?vue&type=template&id=d74c3036"
import script from "./KPIGeneral.vue?vue&type=script&lang=js"
export * from "./KPIGeneral.vue?vue&type=script&lang=js"
import style0 from "./KPIGeneral.vue?vue&type=style&index=0&id=d74c3036&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports